import React from 'react';
import { motion } from 'framer-motion';
export function ForResorts() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-1477">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1478">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1479">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1480">
            {/* Left: Content */}
            <div data-id="element-1481">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1482">
                For Resort Groups
              </p>

              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-8" data-id="element-1483">
                Control your distribution
              </h2>

              <p className="text-lg text-stone-400 leading-relaxed mb-12" data-id="element-1484">
                Stop letting wholesalers capture your margin. BlockQuote gives
                you the infrastructure to own the direct relationship with
                agencies.
              </p>

              <div className="space-y-8" data-id="element-1485">
                <div className="border-l-2 border-red-600 pl-6" data-id="element-1486">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1487">
                    Eliminate wholesale leakage
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1488">
                    Shift group bookings to direct distribution — estimated $6M+
                    annual savings per resort group
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-1489">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1490">
                    Close groups faster
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1491">
                    Instant quotes vs 48–72hr email cycles. Speed wins business.
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-1492">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1493">
                    Pricing governance
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1494">
                    Enforce rate floors and concession policies automatically
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-1495">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1496">
                    Operational efficiency
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1497">
                    Reduce manual quoting workload by 60%+ for sales teams
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Data display */}
            <div className="border border-stone-700" data-id="element-1498">
              <div className="border-b border-stone-700 p-6" data-id="element-1499">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-1500">
                  Revenue Dashboard
                </p>
              </div>

              <div className="border-b border-stone-700 p-6" data-id="element-1501">
                <div className="flex justify-between items-baseline mb-2" data-id="element-1502">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1503">
                    Direct Group Revenue
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1504">YTD</p>
                </div>
                <p className="font-mono text-4xl text-stone-50" data-id="element-1505">$4,250,000</p>
                <p className="font-mono text-sm text-red-600 mt-2" data-id="element-1506">+24% YoY</p>
              </div>

              <div className="border-b border-stone-700 p-6" data-id="element-1507">
                <div className="flex justify-between items-baseline mb-2" data-id="element-1508">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1509">
                    Leakage Prevented
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1510">Q4</p>
                </div>
                <p className="font-mono text-4xl text-stone-50" data-id="element-1511">$382,500</p>
              </div>

              <div className="p-6" data-id="element-1512">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1513">
                  Quote Velocity
                </p>
                <div className="flex gap-1 h-3" data-id="element-1514">
                  <div className="bg-red-600 flex-[85]" data-id="element-1515"></div>
                  <div className="bg-stone-700 flex-[15]" data-id="element-1516"></div>
                </div>
                <div className="flex justify-between mt-2" data-id="element-1517">
                  <p className="font-mono text-xs text-stone-500" data-id="element-1518">
                    Instant (85%)
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1519">
                    Manual (15%)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}